export default "__VITE_ASSET__8a7cd409__"